import {createContext} from "react";

// TODO: Why is this required?

export const ReportViewPopupContext = createContext<{
    isPopupOpened: boolean;
    open: () => void;
    close: () => void;
}>({
    isPopupOpened: false,
    open: () => null,
    close: () => null,
});
